import styled from 'styled-components';
import { units } from '@m/alchemy-ui/theme';

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${units(2)};
  flex-wrap: wrap;
`;

export const SortContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${units(1)};
`;

export const SortLabel = styled.span`
  font-weight: 600;
  white-space: nowrap;
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${units(2)};
`;

export const EmptyState = styled.p`
  padding: ${units(2)};
  text-align: center;
  color: #888;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${units(4)};
`;

export const IdeaList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
